<template>
    <div>
        <el-row>
            <el-col class="file-group" :span="6">
            </el-col>
            <el-col class="" :span="18">
                <el-button @click="chooseImage" :disabled="selectList.length === 0">使用选中图片</el-button>
                <el-upload
                        style="display: inline-block;margin: 0 10px"
                        :action="fileUrl"
                        :before-upload="beforeUpload"
                        :headers="header"
                        :data="uploadData"
                        :multiple="true"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        multiple>
                    <el-button type="primary">上传图片</el-button>
                </el-upload>
                <el-button :disabled="selectList.length === 0" @click.stop="deleteImage()">删除图片</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col class="file-group" :span="6">
                <div class="nav">
                    <div class="group-tree">
                        <el-tree
                                :data="groups"
                                node-key="group_id"
                                @node-click="onSelectGroup">
                            <template #default="{ node, data }">
                            <span class="custom-tree-node">
                                <span>{{ data.name }}</span>
                            </span>
                            </template>
                        </el-tree>
                    </div>
                    <div class="acea-row row-center" @click="addGroup">
                        <el-button type="text">新增分组</el-button>
                    </div>
                </div>
            </el-col>
            <el-col class="file-list-warper" :span="18">
                <div class="file-list">
                    <div class="file-item" @click.stop="selectImage(item, index)" v-for="(item, index) in lists">
                        <div class="file-image">
                            <el-badge class="number" :value="item.num" v-if="item.num > 0">
                            </el-badge>
                            <img :class="item.isSelect ? 'on' : ''" :src="item.external_url">
                        </div>
                        <div class="file-name line1">{{item.file_name}}</div>
                    </div>
                </div>
                <!-- 分页组件 -->
                <el-pagination
                        :current-page="formItem.page"
                        :page-size="formItem.limit"
                        :total="total"
                        :background="true"
                        goto="'前往'"
                        @current-change="pageCurrentChange"
                        class="ele-pagination-circle"/>
            </el-col>
        </el-row>
        <el-dialog v-model="groupDialog" title="新增文件分组" width="440px" :before-close="cancelDialog">
            <el-form :model="FromData" ref="FromData">
                <el-form-item label="分组名称" :label-width="100" prop="name" :rules="[
                { required: true, message: '请输入分组名称', trigger: 'blur' }
            ]">
                    <el-input v-model="FromData.name" autocomplete="off" />
                </el-form-item>
                <el-form-item label="上级分组" :label-width="100">
                    <el-select v-model="FromData.parent_id" placeholder="上级分类" style="width: 100%;">
                        <el-option :value="group.group_id" v-for="(group, index) in file_groups" :label="group.name">{{group.name}}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" :label-width="100">
                    <el-input v-model="FromData.sort" autocomplete="off" />
                </el-form-item>
            </el-form>
            <template #footer>
            <span class="dialog-footer">
                <el-button @click="cancelDialog">取消</el-button>
                <el-button type="primary" @click="onSubmit('FromData')">确定</el-button>
            </span>
            </template>
        </el-dialog>
    </div>

</template>

<script>
    import * as File from '@/api/file';
    import Setting from "@/setting";
    import util from "@/libs/util";

    export default {
        name: "fileImages",
        props: {
            isChoice: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                fileUrl: Setting.apiBaseURL + "/channel/upload/image",
                groupDialog: false,
                groups: [],
                file_groups: [],
                FromData: {
                    group_id: 0
                },
                uploadData: {
                    group_id: 0
                },
                lists: [
                ],
                total: 0,
                formItem: {
                    page: 1,
                    limit: 15,
                    group_id: 0
                },
                header: {

                },
                selectList: [],
            }
        },
        created() {
            this.getToken()
            this.groups.push({
                group_id: 0,
                name: '全部',
                children: []
            })

            this.getGroupList()
            this.getList()
        },
        methods: {
            // 上传头部token
            getToken() {
                this.header["Authori-zation"] = "Bearer " + util.cookies.get("token");
            },
            pageCurrentChange (page) {
                this.formItem.page = page;
                this.getList();
            },
            getGroupList: function () {
                var _this = this
                File.groupList({
                }).then(function (res) {
                    if (res.code == 1) {
                        var file_groups = res.data.list
                        _this.file_groups = file_groups

                        _this.groups = JSON.parse(JSON.stringify(file_groups))
                        _this.groups.unshift({
                            group_id: 0,
                            name: '全部',
                            children: []
                        })
                    }
                })
            },
            addGroup: function () {
                this.groupDialog = true
            },
            cancelDialog: function () {
                this.groupDialog = false
                this.FromData = {
                    group_id: 0
                }
            },
            onSubmit: function (name) {
                var _this = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.FromData.group_id) {
                            var group_id = this.FromData.group_id
                            var form = JSON.parse(JSON.stringify(this.FromData))
                            delete form.group_id
                            File.groupEdit({
                                form: form,
                                group_id: group_id
                            }).then(function (res) {
                                if (res.code == 1) {
                                    _this.$message.success(res.msg)
                                    _this.cancelDialog()
                                    _this.getGroupList()
                                }
                            })
                        } else {
                            File.groupAdd({
                                form: JSON.parse(JSON.stringify(this.FromData))
                            }).then(function (res) {
                                if (res.code == 1) {
                                    _this.$message.success(res.msg)
                                    _this.cancelDialog()
                                    _this.getGroupList()
                                }
                            })
                        }
                    }
                })
            },
            onSelectGroup: function (group) {
                this.formItem.group_id = group.group_id
                this.formItem.page = 1
                this.uploadData.group_id = group.group_id
                this.getList()
            },
            getList: function () {
                var _this = this
                File.fileList(this.formItem).then(function (res) {
                    if (res.code == 1) {
                        let data = res.data.list
                        _this.lists = data.data
                        _this.total = data.total
                        _this.loading = false;
                    }
                })
            },
            // 上传成功
            handleSuccess(res, file, fileList) {
                if (res.code === 1) {
                    this.formItem.page = 1
                    this.$message.success(res.msg);
                    this.getList();
                } else {
                    this.$message.error(res.msg);
                }
            },
            selectImage: function (item, index) {
                let activeIndex = 0;
                if (!item.isSelect) {
                    item.isSelect = true;
                    this.selectList.push(item);
                } else {
                    item.isSelect = false;
                    this.selectList.map((el, index) => {
                        if (el.file_id == item.file_id) {
                            activeIndex = index;
                        }
                    });
                    this.selectList.splice(activeIndex, 1);
                }

                this.ids = [];
                this.selectList.map((item, i) => {
                    this.ids.push(item.file_id);
                });

                this.lists.map((el, i) => {
                    if (el.isSelect) {
                        this.selectList.filter((el2, j) => {
                            if (el.file_id == el2.file_id) {
                                el.num = j + 1;
                            }
                        });
                    } else {
                        el.num = 0;
                    }
                });
            },
            deleteImage: function () {
                if (this.selectList.length == 0) {
                    return false;
                }

                var _this = this
                this.$messageBox.confirm(
                    '确定要删除选中图片吗？\n' +
                    '删除选中图片后将无法恢复，请谨慎操作!',
                    '删除选中图片',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                )
                .then(() => {
                    var ids = [];
                    this.selectList.forEach(function (file) {
                        ids.push(file.file_id)
                    })
                    File.fileDelete({file_ids: ids}).then(function (res) {
                        if (res.code == 1) {
                            _this.$message.success(res.msg)
                            _this.selectList  = [];
                            _this.getList()
                        }
                    })
                })
                .catch(() => {

                })
            },
            chooseImage: function () {
                if (this.isChoice == 1) {
                    if (this.selectList.length > 1)
                        return this.$message.warning("最多只能选一张图片");
                    this.$emit("getPic", this.selectList[0]);
                    this.clearSelect()
                } else {
                    let maxLength = this.$route.query.maxLength;
                    if (
                        maxLength != undefined &&
                        this.selectList.length > Number(maxLength)
                    )
                        return this.$message.warning("最多只能选" + maxLength + "张图片");
                    this.$emit("getPicD", this.selectList);
                    this.clearSelect()
                }
            },
            clearSelect: function () {
                this.selectList  = [];
                this.lists.forEach((item) => {
                    item.isSelect = false
                })
            }
        }
    }
</script>

<style scoped lang="less">
.file-group .nav{
    width: 90%;
    border-right: 1px solid #e6e6e6;
}
.group-tree{
    height: 400px;
}
.file-list-warper{
    margin: 0 -8px;
}
.file-list{
    .file-item{
        position: relative;
        width: 100px;
        height: 125px;
        cursor: pointer;
        margin: 5px 8px;
        padding: 0;
        border-radius: 3px;
        display: inline-block;
        .file-image{
            width: 100px;
            height: 100px;
            background-color: #f0f0f0!important;
            img{
                width: 100%;
                height: 100%;
                object-fit: contain;
                border: 2px solid #ffffff;
            }
            img.on{
                border: 2px solid #5fb878
            }
            .number{
                height: 33px;
                position: absolute;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
            }
        }
        .file-name{
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #fff!important;
            padding: 5px;
        }
    }
}
</style>
